/**
 * HE.Form
 *
 * @author Patrick Verrier <pverrier@cruiseplanners.com>
 */

(function Form($, HE)
{
	"use strict";

	var form = {
		componentForms: {},
		submitting    : false,
	};

	var _submit,
	    _errorHandler,
	    _cleanUp,
	    _initForm;

	// init all forms currently on the page
	$(document).ready(function documentReady() {
		_initForm($('form[data-form-component]'));

		// this isn't specifically for forms, but any input group textbox
		// with a "clear" button should have its input cleared
		$(document).on('click', '.input-group button[role="clear"]', function clearTextInput() {
			var $input = $(this).prev('input');

			if ($input.val()) {
				$input.val('').trigger('cleared');
			}
		});
	});

	/**
	 * Initializes a component form loaded via AJAX to be processed by this system.
	 *
	 * @param  string form_name Form name of component form to be initialized.
	 */
	form.initAjaxForm = function initAjaxForm(form_name)
	{
		var $form = $('form[name="' + form_name + '"]'),
		    form_obj;

		if (_initForm($form)) {
			// if form has been registered, run .load()
			if (form_name in form.componentForms) {
				form_obj         = form.componentForms[form_name];
				form_obj.element = $form[0];

				if (typeof form_obj.load === 'function') {
					form_obj.load($form);
				}
			}
		}
	};

	/**
	 * initializes a form regardless of origin (static/ajax).
	 * this inits:
	 * 	form submit handlers
	 * 	textarea auto resizing
	 * 	recipient selection
	 * 	destination selection
	 * 	multiselects
	 * 	phone number auto formatting
	 * 	"check all" checkboxes
	 * 	image cropers
	 * 	integer-only fields
	 * 	airline typeaheads
	 * 	airport typeaheads
	 * 	date/time pickers
	 * 	force uppercase input
	 */
	_initForm = function _initForm($forms)
	{
		var _textareaResize;
		var __textareaResize = function __textareaResize($el) {
			var offset = $el[0].offsetHeight - $el[0].clientHeight;
			$el.css('height', $el[0].scrollHeight + offset);
		};

		if (!$forms.length) {
			return false;
		}

		// setup form submit handlers
		$forms.on('submit', _submit);


		// textarea autoresizing
		_textareaResize = HE.Debounce(__textareaResize, 150);

		$.each($forms.find('textarea[data-autoresize]'), function __initTextareaAutoResize() {
			var $self  = $(this);

			$self.on('keyup', function __textareaKeyup() {
				_textareaResize($self);
			});

			__textareaResize($self);
		});

		// recipient selection
		// $.each($forms.find('div.recipient-selection'), function __initRecipientSelection() {
		// 	HE.RecipientSelection($(this));
		// });

		// destination selection
		// $.each($forms.find('div.destination-selection'), function __initDestinationSelection() {
		// 	HE.DestinationSelection($(this));
		// });

		// multi-selects
		// $.each($forms.find('select[multiple]'), function __initMultiSelect() {
		// 	var $self              = $(this);
		// 	var include_select_all = false;
		// 	var live_search        = false;

		// 	if ($self.data('include-select-all')) {
		// 		include_select_all = true;
		// 	}

		// 	if ($self.data('live-search')) {
		// 		live_search = true;
		// 	}

		// 	$self.selectpicker({
		// 		actionsBox        : include_select_all,
		// 		selectedTextFormat: 'count',
		// 		size              : 10,
		// 		liveSearch        : live_search,
		// 	});

		// 	// fired by custom valHooks, see HotelEngine\_global.js
		// 	$self.on('changed.bs.select', function refreshSelectVal(e, argv) {
		// 		if (argv && typeof argv === 'object' && argv.programmatic) {
		// 			$(this).selectpicker('refresh');
		// 		}
		// 	});
		// });


		// phone number fields
		$.each($forms.find('input.phone-number'), function __initPhoneNumberInput() {
			var $self = $(this);
			var formatted = '';

			$self.on('blur', function __formatPhoneNumber() {
				// first, remove any non alpha numeric chars in case they've entered parens, for example.
				// then format the string like the hard-core php phone validation
				formatted  = $self.val().replace(/\W/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');

				if ($self.val().replace(/[^0-9]/g, "").length === 10) {
					$self.val(formatted);
				}
			});
		});


		// "check all" checkboxes
		$.each($forms.find('input[type="checkbox"].check-all'), function __initCheckAll() {
			var $self = $(this);

			$self.on('change', function _toggleCheckAll() {
				var checked = $self.prop('checked');
				if (checked) {
					$self.parents('form').find('input[type="checkbox"]:not(.check-all):not(:disabled):not(:checked)').prop('checked', checked).trigger('change');
				} else {
					$self.parents('form').find('input[type="checkbox"]:not(.check-all):not(:disabled):checked').prop('checked', checked).trigger('change');
				}
				$('body').trigger('check-all-done', [checked]);
			});
		});

		// image croppers
		// $.each($forms.find('input[data-form-component-image]'), function __initImageCropper() {
		// 	HE.ImageCropper($(this));
		// });

		// force integer input
		$.each($forms.find('input.force-integer'), function __initIntInput() {
			var $self = $(this);

			// only allow integer chars to be typed in
			$self.keypress(function keyp(event) {
				var charCode = event.charCode;
				if ( (charCode < 48) || (charCode > 57) ) {
					return false;
				}
			});

			// if user attempts to paste a string with non-ints, strip out the non-int characters
			$self.on("paste", function paste(event) {
				var $in = $(this);

				setTimeout(function delay() {
					var current_val = $in.val(),
					    forced_val  = current_val.replace(/\D/g, '');
					    $in.val(forced_val);
				}, 1);
			});
		});

		// force uppercase input
		$.each($forms.find('input.force-uppercase'), function __initUppercaseInput() {
			var $self = $(this);

			$self.keyup(function onKeyup(event) {
				var val = String($self.val());
				$self.val(val.toUpperCase());
			});
		});

		// airline typeaheads
		$.each($forms.find('input.airline'), function __initAirlineTypeahead() {
			HE.Typeahead(
				$(this),
				'/Airlines/search',
				function __selected_airline(airline, $self, typeahead) {
					if (airline.id) {
						typeahead.setHiddenValue(airline.id);
					} else {
						$self.val('');
					}
				}
			);
		});

		// airport typeaheads
		$.each($forms.find('input.airport-typeahead'), function __initAirportTypeahead() {
			HE.Typeahead(
				$(this),
				'/Airports/search',
				function __selected_airport(airport, $self, typeahead) {
					if (airport.id) {
						typeahead.setHiddenValue(airport.id);
					} else {
						$self.val('');
					}
				}
			);
		});

		// group typeaheads
		$.each($forms.find('input.group-typeahead'), function __initGroupTypeahead() {
			var include_ho   = $(this).data('include-ho'),
			    include_opps = $(this).data('include-opps'),
			    url          = '/Groups/searchGroups/' + include_ho + '/' + include_opps + '/';

			HE.Typeahead(
				$(this),
				url,
				function __selected_group(group, $self, typeahead) {
					var $hidden_source = $('#' + $self.data('hidden-source'));

					if (group.id) {
						typeahead.setHiddenValue(group.id);

						if ($hidden_source.length > 0) {
							$hidden_source.val(group.group_source);
						}

					} else {
						$self.val('');

						if ($hidden_source.length > 0) {
							$hidden_source.val('');
						}
					}
				}
			);
		});

		// reservation typeaheads
		$.each($forms.find('input.reservation-typeahead'), function __initReservationTypeahead() {
			HE.Typeahead(
				$(this),
				'/Reservations/searchReservations',
				function __selected_reservation(reservation, $self, typeahead) {
					if (reservation.id) {
						typeahead.setHiddenValue(reservation.id);
					} else {
						$self.val('');
					}
				}
			);
		});

		// currency inputs should be positive float values with a precision of 2
		$.each($forms.find('input.price-field'), function __initIntInput() {
			var $self = $(this);

			$self.data('fc-old-value', $self.val());

			if ($self.hasClass('zero-default')) {
				if ($self.val() === '') {
					$self.val('0.00');
				}

				$self.on('focus', function __blankZero() {
					var $input = $(this);

					if (parseFloat($input.val()) === 0 && !$input.prop('readonly')) {
						$input.val('');
					}
				});
			}

			$self.on('change keyup paste', function __forceCurrency() {
				var $input          = $(this),
					new_value       = $input.val(),
					old_value       = $input.data('fc-old-value'),
					formatted_value;

				if (new_value !== old_value) {
					if (new_value === '') {
						$input.data('fc-old-value', '');

						if (old_value !== '') {
							$input.trigger('pricechanged');
						}

						return;
					}

					if (new_value.match(/[^\d\.]/g) !== null) {
						$input.val(old_value);

						return;
					}

					if (new_value.match(/\./g) !== null && new_value.match(/\./g).length > 1) {
						$input.val(old_value);

						return;
					}

					if (isNaN(parseFloat(new_value))) {
						$input.val(old_value);

						return;
					}

					formatted_value = accounting.formatNumber(new_value, 2, '');

					if ((parseFloat(new_value) - parseFloat(formatted_value)) !== 0) {
						$input.val(formatted_value);

						new_value = formatted_value;
					}

					if (new_value !== old_value) {
						$input.data('fc-old-value', new_value);

						$input.trigger('pricechanged');
					}
				}
			});

			$self.on('blur', function __formatCurrency() {
				var $input = $(this),
				    value  = $input.val();

				if (!$input.prop('readonly')) {
					if (value !== '') {
						$input.val(accounting.formatNumber(value, 2, ''));
					} else if ($input.hasClass('zero-default')) {
						$input.val('0.00');
					}
				}
			});
		});

		// date ranges
		$.each($forms.find('input[data-daterange]'), function initDateRange(i, el)
		{
			var $el               = $(el),
			    $check_in_hidden  = $el.siblings('[id$="check_in"]'),
			    $check_out_hidden = $el.siblings('[id$="check_out"]');

			(function _initDateRange($check_in, $check_out) {
				var opts = {
					// autoApply: true,
				};

				if ($el.data('position')) {
					opts.opens = $el.data('position');
				}

				if ($el.data('clear')) {
					opts.locale = { cancelLabel: 'Clear' };
				}

				if ($el.data('date-format')) {
					if (opts.locale) {
						opts.locale.format = $el.data('date-format');
					}
					else {
						opts.locale = { format: $el.data('date-format') };
					}
				}

				if ($el.data('start-empty')) {
					opts.autoUpdateInput = false;
				}

				opts.autoApply = true;

				$el.daterangepicker(opts);

				if ($el.data('clear')) {
					$el.on('cancel.daterangepicker', function _dateRangeClearInput(ev, picker) {
						$(this).val('');
					});
				}

				// if you want the input to start blank, autoUpdateInput disables
				// filling the field in entirely, for some stupid reason.
				// so this restores that functionality.
				if ($el.data('start-empty')) {
					$el.on('apply.daterangepicker', function _dateRangePopulateInput(ev, picker) {
						$(this).val(picker.startDate.format('MM/DD/YYYY') + ' - ' + picker.endDate.format('MM/DD/YYYY'));
					});
				}

				if ($check_in.length && $check_out.length) {
					$el.on('hide.daterangepicker', function _dateRangeUpdateInputs(ev, picker) {
						$check_in.val(picker.startDate.format('YYYY-MM-DD'));
						$check_out.val(picker.endDate.format('YYYY-MM-DD'));
					});
				}
			}($check_in_hidden, $check_out_hidden));
		});

		// single-date picker
		$.each($forms.find('input[data-date]'), function initDate(i, el)
		{
			var $el  = $(el);
			var opts = {
				singleDatePicker: true,
				autoApply       : true,
				// minYear: parseInt(moment().format('YYYY')),
			};

			if ($el.data('direction')) {
				opts.drops = $el.data('direction');
			}

			if ($el.data('date-format')) {
				if (opts.locale) {
					opts.locale.format = $el.data('date-format');
				}
				else {
					opts.locale = { format: $el.data('date-format') };
				}
			}

			if ($el.data('start-empty')) {
				opts.autoUpdateInput = false;
			}

			$el.daterangepicker(opts);

			if ($el.data('start-empty')) {
				$el.on('apply.daterangepicker', function _dateRangePopulateInput(ev, picker) {
					$(this).val(picker.startDate.format('MM/DD/YYYY'));
				});
			}

		});

		$.each($forms.find('.html-editor'), function initEditor() {
			var $self   = $(this),
				options = {};

			// options for the editor may be set in data attributes. they need to be named like data-editor-options-height="400", as an example.
			// this code will use those options with init the editor
			$.each($self.data(), function addOptions(key, val) {
				var option_key;

				if (key.indexOf('editorOptions') === 0) {
					option_key = key.replace("editorOptions", "").toLowerCase();

					options[option_key] = val;
				}
			});

			HE.Editor('#' + $self.attr('id'), options);
		});



		// todo: multi-handle sliders

		// enable submit buttons now that form is init
		$forms.find('[type=submit]').prop('disabled', false);

		return true;
	};

	/**
	 * Method bound to all forms which intercepts submission and handles it via AJAX instead.
	 *
	 * @param  object e Event object.
	 */
	_submit = function _submit(e)
	{
		var self           = this,
		    $self          = $(this),
		    $file_inputs   = $self.find('input[type="file"]'),
		    attribute_data = {},
		    this_form      = form.componentForms[self.name],
		    $file_input,
		    data;

		e.preventDefault();

		// Check for TinyMCE fields and trigger save, if any
		if ($self.find('.html-editor').length > 0) { // Adjust '.html-editor' selector if necessary
			tinymce.triggerSave(true, true); // Triggers TinyMCE save
		}

		// fix safari 11.x bug that breaks everything if there's an empty file input
		if ($file_inputs) {
			$.each($file_inputs, function safari11BugFix(i, input) {
				$file_input = $(input);

				if (!$.trim($file_input.val())) {
					$file_input.data('name', $file_input.attr('name'));
					$file_input.removeAttr('name');
				} else if ($file_input.data('name')) {
					$file_input.attr('name', $file_input.data('name'));
				}
			});
		}

		data = new FormData(this);

		if (form.submitting) {
			return;
		}

		if (this_form !== undefined)
		{
			if (this_form.confirm_before_submit && !this_form.confirmed)
			{
				HE.CustomConfirm({
					body   : (this_form.confirm_message) ? this_form.confirm_message : null,
					confirm: function confirmed() {
						this_form.confirmed = true;
						$self.submit();
					}
				});

				return false;
			}
		}

		form.submitting = true;

		$self.find('.has-error').removeClass('has-error').trigger('errorClassRemoved');

		$self.find('button[type="submit"]').addClass('disabled');

		$self.find('.form-loader').css('visibility', 'visible');

		$self.find(':input').each(function inputIterator(i, input)
		{
			var $input           = $(input),
			    input_attributes = {},
			    name,
			    last_key;

			$.each(input.attributes, function attributeIterator(j, attribute)
			{
				if (attribute.name !== 'value') {
					input_attributes[attribute.name] = attribute.value;
				}
			});

			if ($input.data('name')) {
				input_attributes['name'] = $input.data('name');
			}

			if ('name' in input_attributes) {
				name = input_attributes['name'];

				// eslint-disable-next-line no-magic-numbers
				if (name.substr(0, 20) === 'form_component_data[') {
					// eslint-disable-next-line no-magic-numbers
					name = input_attributes['name'].slice(10, -1).replace(/\]\[/g, '.');

					last_key = name.match(/.([^.]*)$/)[1];

					if (last_key === '' || parseInt(last_key).toString() === last_key) {
						name = name.replace(/.[^.]*$/, '');
					}

					name = name.replace(/^[^.]*./, '');
				}

				if (!(name in attribute_data)) {
					if (!('type' in input_attributes)) {
						input_attributes['type'] = $(input).prop('tagName').toLowerCase();
					}

					attribute_data[name] = input_attributes;
				}
			}
		});

		data.append('form_component_attribute_data', JSON.stringify(attribute_data));

		$.ajax({
			url        : $self.attr('action'),
			type       : 'POST',
			data       : data,
			processData: false,
			contentType: false,
			success    : function successHandler(response)
			{
				var error_message   = '';

				if (this_form !== undefined) {
					this_form.confirmed = false;
				}

				if (typeof response === 'string') {
					_errorHandler(self, 'parsererror', response);

					return;
				}

				if (self.name in form.componentForms && typeof form.componentForms[self.name].success === 'function') {
					if (!form.componentForms[self.name].success(response)) {
						_cleanUp(self);
					}
				} else {
					switch (response['status']) {
						case 'validation_error':
							error_message = HE.Form.handleValidationErrors(response['data']);
							if ('custom_error' in response) {
								error_message = response['custom_error'];
							}
							HE.Form.throwSubmissionError(error_message);

							_cleanUp(self);
							break;

						case 'confirmation_prompt':
							if (self.name in form.componentForms && typeof form.componentForms[self.name].confirmation === 'function') {
								form.componentForms[self.name].confirmation(response);
							} else {
								console.log('A status of "confirmation_prompt" is being returned by the form. The intent when "confirmation_prompt" is returned is for a confirmation() method to be defined in the form\'s custom JS file and for the user to be given an option to confirm or decline the prompt. The received response is below.');
								console.log(response);
							}

							_cleanUp(self);
							break;

						case 'processing_error':
							error_message = HE.Form.buildProcessingError(response['data']);
							HE.Form.throwSubmissionError(error_message);

							_cleanUp(self);
							break;
						default:
							window.location.href = response['data'];
							break;
					}
				}
			},
			error: function errorHandler(jq_xhr, error)
			{
				if (this_form !== undefined) {
					this_form.confirmed = false;
				}
				_errorHandler(self, error, jq_xhr.responseText);
			},
		});
	};

	/**
	 * Handles unknown form errors.
	 *
	 * @param  object form_element Form element of the form that the unknown error occurred for.
	 */
	_errorHandler = function _errorHandler(form_element, error, response)
	{
		if (HE.dev && error === 'parsererror') {
			HE.StatusMessage(
				'warning',
				'A non-JSON string was received from the server, displaying below for debugging purposes:<br><br><div class="form-debugger">' + response + '</div>',
				'Warning',
				{
					bg_dismiss  : true,
					column_class: 'col-md-8 col-md-offset-2',
				}
			);
		} else if (form_element.name in form.componentForms && typeof form.componentForms[form_element.name].error === 'function') {
			form.componentForms[form_element.name].error(error, response);
		} else {
			HE.StatusMessage('Error', 'An unknown error has occurred. Please try submitting the form again in a few minutes.');
		}

		_cleanUp(form_element);
	};

	/**
	 * Cleans up after a form has been submitted but does not trigger a redirect.
	 *
	 * @param  object form_element Form element of the form to clean up.
	 */
	_cleanUp = function _cleanUp(form_element)
	{
		$(form_element).find('.form-loader').css('visibility', 'hidden');

		$(form_element).find('button[type="submit"]').removeClass('disabled');

		form.submitting = false;
	};

	/**
	 * Registers a component form to be processed by this system.
	 *
	 * @param  object form_obj Form object of component form to be registered.
	 */
	form.registerForm = function registerForm(form_obj)
	{
		var $form_jqo = $('form[name="' + form_obj.name + '"]');

		// eslint-disable-next-line no-magic-numbers
		if ($form_jqo.length > 0) {
			form_obj.element = $form_jqo[0];

			if (typeof form_obj.load === 'function') {
				form_obj.load($form_jqo);
			}
		}

		form.componentForms[form_obj.name] = form_obj;
	};

	form.forceFloat = function forceFloat($jElement)
	{
		var max_decimals = 2,
		    stripped     = $jElement.val().replace(/[^\d\.\-]/g, ''),   // strip out any commas for example
		    entered      = parseFloat(stripped),
		    forced_value = entered.toFixed(max_decimals);

		if (isNaN(forced_value)) {
			forced_value = 0;
			forced_value = forced_value.toFixed(max_decimals);
		}

		$jElement.val(forced_value);
	};

	/**
	 * Builds the HTML for validation errors.  By default will also add a class to the fields that failed validation.
	 *
	 * @param  object  response_data     validation errors
	 * @param  boolean highlight_fields  only set to false if you don't want the fields that failed validation to be highlighted. Maybe you want to do something custom instead?  Otherwise don't pass in this param
	 */
	form.handleValidationErrors = function handleValidationErrors(response_data, highlight_fields)
	{
		var error_message = '',
		    add_class     = true,
		    input_jqo,
		    _focus;

		if (typeof highlight_fields === "boolean") {
			add_class = highlight_fields;
		}

		error_message    += '<ul>';

		// eslint-disable-next-line guard-for-in, no-inner-declarations, vars-on-top
		for (var i in response_data) {
			// eslint-disable-next-line guard-for-in, no-inner-declarations, vars-on-top
			for (var j in response_data[i]['errors']) {
				error_message += '<li>' + response_data[i]['errors'][j] + '</li>';
			}

			// support highlighting multiple fields per error
			if (response_data[i][0] === undefined) {
				if (response_data[i]['attributes']) {
					if (response_data[i]['attributes']['id']) {
						input_jqo = $('#' + response_data[i]['attributes']['id']);
					}
					else {
						input_jqo = $('input[name="' + response_data[i]['attributes']['name'] + '"]');
					}

					if (add_class === true) {
						markErrorFields(input_jqo);
					}

					if (i === '0') {
						if (input_jqo.is(":visible")) {
							input_jqo.focus();
						} else {
							_focus = input_jqo.parents('.form-group').find('input:visible');

							if (_focus[0]) {
								_focus[0].focus();
							}
						}
					}
				}
			}
			else
			{
				// eslint-disable-next-line guard-for-in, no-inner-declarations, vars-on-top
				for (var y in response_data[i])
				{
					if (y === 'errors') {
						continue;
					}

					if (response_data[i][y]['attributes']) {
						if (response_data[i][y]['attributes']['id']) {
							input_jqo = $('#' + response_data[i][y]['attributes']['id']);
						}
						else {
							input_jqo = $('input[name="' + response_data[i][y]['attributes']['name'] + '"]');
						}

						if (add_class === true) {
							markErrorFields(input_jqo);
						}
					}
				}
			}

		}

		error_message += '</ul>';

		return error_message;
	};

	/**
	 * Builds the HTML for a form processing error
	 *
	 * @param string response_data form processing error message
	 */
	form.buildProcessingError = function buildProcessingError(response_data)
	{
		var error_message = '<ul><li>' + response_data + '</li></ul>';
		return error_message;
	};

	/**
	 * When there is a validation or processing error, use this function to throw an alert to the user.
	 *
	 * @param string custom_error_message whatever additional message you intend to provide below the basic message.
	 */
	form.throwSubmissionError = function throwSubmissionError(custom_error_message)
	{
		var error_message = 'The form could not be submitted for the following reason(s):<br><br>';
		error_message    += custom_error_message;

		HE.StatusMessage('Error', error_message);
	};

	/**
	 * Checks if there is a validation error or processing error and throws error message if there is
	 * @param  object  response  response from an attempted form submission
	 * @return boolean           true if there is an error, false if it's all good
	 */
	form.hasError = function hasError(response)
	{
		var error_message = '';

		if ( (response !== null) && ((response.status === 'validation_error') || (response.status === 'processing_error')) ) {

			if (response.status === 'validation_error') {
				error_message = HE.Form.handleValidationErrors(response['data']);
			} else {
				error_message = HE.Form.buildProcessingError(response['data']);
			}

			if ('custom_error' in response) {
				error_message = response['custom_error'];
			}

			HE.Form.throwSubmissionError(error_message);

			return true;
		}

		return false;
	};

	/**
	 * By default will also add a class of "has-error" to the fields' form-group that failed validation.
	 * @param  {jQuery obj} $input the field that failed validation
	 */
	function markErrorFields($input)
	{
		var $parent = $input.parents('.form-group'),
		    $el;
		if ($parent.length > 0) {
			$el = $parent;
		} else {
			$el = $input.parent();
		}

		// per-element highlighting
		// for whole-form validation, add the class to the form
		$el.addClass('was-validated').trigger('errorClassAdded');
	}

	HE.Form = form;
}(jQuery, window.HE || {}));